const defaultState = {
    refillRules: null,
    fetched: false,
    isFetching: false,
    isError: false,
};

export default function refillRules(state = defaultState, action) {
    switch (action.type) {
        case 'REQUEST_REFILL_RULE':
            return {
                ...state,
                isFetching: true,
            };
        case 'RECEIVE_REFILL_RULE':
            return {
                ...state,
                isFetching: false,
                isError: false,
                fetched: true,
                refillRules: action.refillRules,
            };
        case 'RECEIVE_REFILL_RULE_ERROR':
            console.error(action.error);
            return {
                ...state,
                isFetching: false,
                isError: false,
                fetched: true,
                refillRules: null,
                error: action.error.toString(),
            };
        default:
            return state;
    }
}
